import { FC } from 'react';
import { Badge } from '@new/common/ui/Badge/Badge';
import { DateRangeFilter } from '@new/common/ui/DateRangeFilter/DateRangeFilter';
import { useCourseHearingsContext } from '../../context/CourseHearingsContext';
import { HEARING_DATE_PRESETS } from '../../constants/courseHearings.constants';

export const HearingDateFilter: FC = () => {
  const { dateFrom, setDateFrom, dateTo, setDateTo, datePreset, setDatePreset } =
    useCourseHearingsContext();

  return (
    <div className="flex w-85 flex-col items-start gap-1">
      <DateRangeFilter
        dateFrom={dateFrom}
        dateTo={dateTo}
        onDateFromChange={setDateFrom}
        onDateToChange={setDateTo}
      />

      <div className="flex justify-center gap-2">
        {HEARING_DATE_PRESETS.map(({ label, value }) => (
          <button key={value} onClick={() => setDatePreset(value)} className="cursor-pointer">
            <Badge
              variant={datePreset === value ? 'orange-solid' : 'white'}
              className="px-3 py-1.5 text-sm"
            >
              {label}
            </Badge>
          </button>
        ))}
      </div>
    </div>
  );
};
